import { FiInbox } from "react-icons/fi";

const EmptyState = ({ title, description, actionLabel, onAction, icon: Icon = FiInbox }) => {
  return (
    <div
      className="fade-in"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "4rem 2rem",
        backgroundColor: "var(--color-background-alt, #f8fafc)",
        borderRadius: "1rem",
        border: "1px dashed var(--color-border, #cbd5e1)",
        gap: "10px",
        margin: "0",
      }}
    >
      <div
        style={{
          width: "80px",
          height: "80px",
          backgroundColor: "var(--color-primary-light, #e0ffe1ff)",
          color: "var(--color-primary, #237e22ff)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "0.5rem",
        }}
      >
        <Icon size={40} />
      </div>
      <div style={{ maxWidth: "400px" }}>
        <h3 style={{ fontSize: "1.25rem", fontWeight: "600", color: "var(--color-text, #1e293b)", margin: "0 0 0.5rem 0" }}>
          {title}
        </h3>
        <p style={{ fontSize: "0.95rem", color: "var(--color-text-muted, #64748b)", lineHeight: "1.5", margin: 0 }}>
          {description}
        </p>
      </div>
      {actionLabel && (
        <button
          className="button button--primary"
          onClick={onAction}
          style={{
            marginTop: ".5rem",
            padding: "0.75rem 1.5rem",
            borderRadius: "0.5rem",
            fontWeight: "600",
            transition: "all 0.2s ease-in-out",
            boxShadow: "0 4px 6px -1px rgba(79, 70, 229, 0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(79, 70, 229, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "none";
            e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(79, 70, 229, 0.2)";
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
